import { render, staticRenderFns } from "./StepGroupQuizIntroView.vue?vue&type=template&id=f463b3e2&scoped=true&"
import script from "./StepGroupQuizIntroView.vue?vue&type=script&lang=js&"
export * from "./StepGroupQuizIntroView.vue?vue&type=script&lang=js&"
import style0 from "./StepGroupQuizIntroView.vue?vue&type=style&index=0&id=f463b3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f463b3e2",
  null
  
)

/* custom blocks */
import block0 from "./StepGroupQuizIntroView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports